import { render, staticRenderFns } from "./RequestStatusIcon.vue?vue&type=template&id=b97b5b88&scoped=true"
import script from "./RequestStatusIcon.vue?vue&type=script&lang=ts"
export * from "./RequestStatusIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97b5b88",
  null
  
)

export default component.exports